import type { Components, Theme } from '@mui/material';

import { colors } from '../tokens';
import { shadows } from '../shadows';

export const MuiIconButton: Components<Theme>['MuiIconButton'] = {
  defaultProps: {
    size: 'small',
  },
  variants: [
    {
      props: { variant: 'pill' },
      style: ({ theme }) => ({
        backgroundColor: colors.common.white,
        border: `1px solid ${theme.palette.divider}`,
        boxShadow: shadows[1],
        ...theme.applyStyles('dark', {
          backgroundColor: colors.grayTrue[850],
        }),
      }),
    },
  ],
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: theme.spacing(1),
      '&.Mui-disabled .MuiSvgIcon-root': {
        color: theme.palette.action.disabled,
      },
    }),
    sizeSmall: ({ theme }) => ({
      padding: theme.spacing(0.5),
    }),
    sizeMedium: ({ theme }) => ({
      padding: theme.spacing(1.25),
    }),
    sizeLarge: ({ theme }) => ({
      padding: theme.spacing(1.75),
    }),
  },
};
